import { render } from "./OrderPartAddPayment.vue?vue&type=template&id=43536782&scoped=true"
import script from "./OrderPartAddPayment.vue?vue&type=script&lang=js"
export * from "./OrderPartAddPayment.vue?vue&type=script&lang=js"

import "./OrderPartAddPayment.vue?vue&type=style&index=0&id=43536782&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43536782"]])

export default __exports__